'use strict';

exports.__esModule = true;

var _PathUtils = require('history/PathUtils');

Object.defineProperty(exports, 'parsePath', {
  enumerable: true,
  get: function get() {
    return _PathUtils.parsePath;
  }
});
Object.defineProperty(exports, 'createPath', {
  enumerable: true,
  get: function get() {
    return _PathUtils.createPath;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-history/PathUtils.js
 ** module id = 609
 ** module chunks = 0
 **/